"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _moment = require('moment'); var _moment2 = _interopRequireDefault(_moment);










var _chat = require('shared/enum/chat');
var _phone = require('shared/services/phone');

// Everything staff read about whether BloomText can text a patient: the
// undeliverable list's reasons, the conversation banner, the patient page's
// "Texting" row, the Block List, message delivery badges, broadcast and
// scheduled-message failures, and the mark / resubscribe / block dialogs.
// Web and mobile both render from here so they say the same thing.
//
// Copy never says a block came from another organization: a STOP to an org
// line only blocks that org, and the shared notification number is named as
// BloomText's.

// ---------------------------------------------------------------------------
// Reasons and rows

// Display priority: the single label uses the first org-line row. The
// backend sorts the same way; 'unreachable' (Twilio 30006: a landline or an
// unreachable carrier) comes last.
 const SMS_UNDELIVERABLE_REASON_ORDER =
  ['opted_out', 'carrier_blocked', 'admin_blocked', 'unreachable']; exports.SMS_UNDELIVERABLE_REASON_ORDER = SMS_UNDELIVERABLE_REASON_ORDER

const REASON_LABELS = {
  opted_out: 'Opted out',
  carrier_blocked: 'Blocked by carrier',
  admin_blocked: 'Blocked by admin',
  unreachable: 'Can\'t receive texts',
}

// "Opted out", "Blocked by carrier", "Blocked by admin", "Can't receive texts".
 const smsUndeliverableReasonLabel = (reason) =>
  REASON_LABELS[reason] || 'Not deliverable'; exports.smsUndeliverableReasonLabel = smsUndeliverableReasonLabel

// The same, lower-cased for the middle of a sentence ("…: opted out.").
 const smsUndeliverableReasonPhrase = (reason) =>
  exports.smsUndeliverableReasonLabel.call(void 0, reason).toLowerCase(); exports.smsUndeliverableReasonPhrase = smsUndeliverableReasonPhrase

const EMPTY_ROWS = []

const reasonRank = (reason) => {
  const i = exports.SMS_UNDELIVERABLE_REASON_ORDER.indexOf(reason)
  return i < 0 ? exports.SMS_UNDELIVERABLE_REASON_ORDER.length : i
}

// Rows in display priority (the backend already orders them; this keeps the
// client right if it doesn't). Stable within a reason.
 const sortSMSUndeliverable = (rows) =>
  rows
    .map((row, i) => ({ row, i }))
    .sort((a, b) => reasonRank(a.row.Reason) - reasonRank(b.row.Reason) || a.i - b.i)
    .map(({ row }) => row); exports.sortSMSUndeliverable = sortSMSUndeliverable

// The rows that stop texts from the org's own lines (SMS chats, the
// composer). A Shared row doesn't: it only stops the notification number.
 const orgLineSMSUndeliverable = (
  patient,
) => {
  const rows = _optionalChain([patient, 'optionalAccess', _2 => _2.SMSUndeliverable])
  if (!_optionalChain([rows, 'optionalAccess', _3 => _3.length])) return EMPTY_ROWS
  const orgRows = rows.filter(r => !r.Shared)
  return orgRows.length ? exports.sortSMSUndeliverable.call(void 0, orgRows) : EMPTY_ROWS
}; exports.orgLineSMSUndeliverable = orgLineSMSUndeliverable

// The rows that stop a secure chat's text notifications: the org's rows and
// the shared notification number's, org rows first.
 const notificationSMSUndeliverable = (
  patient,
) => {
  const rows = _optionalChain([patient, 'optionalAccess', _4 => _4.SMSUndeliverable])
  if (!_optionalChain([rows, 'optionalAccess', _5 => _5.length])) return EMPTY_ROWS
  return [...exports.orgLineSMSUndeliverable.call(void 0, patient), ...exports.sortSMSUndeliverable.call(void 0, rows.filter(r => !!r.Shared))]
}; exports.notificationSMSUndeliverable = notificationSMSUndeliverable

// "Not deliverable" means any org-line row. Shared rows matter only for a
// secure chat's notification texts.
 const isSMSDeliverable = (patient) =>
  exports.orgLineSMSUndeliverable.call(void 0, patient).length === 0; exports.isSMSDeliverable = isSMSDeliverable

// The row that names the state: the first non-Shared row, else the first.
 const topSMSUndeliverable = (
  rows,
) => {
  if (!_optionalChain([rows, 'optionalAccess', _6 => _6.length])) return null
  const sorted = exports.sortSMSUndeliverable.call(void 0, rows)
  return sorted.find(r => !r.Shared) || sorted[0] || null
}; exports.topSMSUndeliverable = topSMSUndeliverable

// ---------------------------------------------------------------------------
// Who can clear what (D4)

// The command that clears a patient's row from the patient page or banner:
// a staff opt-out → ResubscribePatientSMS (consent + reason dialog); an admin
// block → UnblockPatientSMS; a number that can't receive texts →
// ClearPatientSMSUnreachable (texts are tried again). The Block List clears admin blocks with
// RemovePhoneNumberBlock instead (phoneNumberBlockClearAction). Rows Twilio
// enforces (the patient's STOP, a carrier block, any Shared row) have none:
// only the patient's START clears them.


 const smsUndeliverableClearAction = (
  row,
) => {
  if (row.Shared || !row.AdminClearable) return null
  if (row.Reason === 'admin_blocked') return 'UnblockPatientSMS'
  if (row.Reason === 'unreachable') return 'ClearPatientSMSUnreachable'
  if (row.Reason === 'opted_out' && row.Source === 'staff') return 'ResubscribePatientSMS'
  return null
}; exports.smsUndeliverableClearAction = smsUndeliverableClearAction

// Whether this viewer may clear the row: admins, and only rows the backend
// marks AdminClearable.
 const canClearSMSUndeliverable = (
  row,
  isAdmin,
) => isAdmin && exports.smsUndeliverableClearAction.call(void 0, row) !== null; exports.canClearSMSUndeliverable = canClearSMSUndeliverable

const CLEAR_LABELS = {
  ResubscribePatientSMS: 'Resubscribe',
  UnblockPatientSMS: 'Unblock',
  ClearPatientSMSUnreachable: 'Clear',
}

 const smsUndeliverableClearLabel = (action) => CLEAR_LABELS[action]; exports.smsUndeliverableClearLabel = smsUndeliverableClearLabel

// The Block List's Unblock: admin_blocked rows only. A staff opt-out or an
// unreachable number is AdminClearable too, but it clears from the patient
// page or the banner.
 const phoneNumberBlockClearAction = (
  block,
) =>
  block.Reason === 'admin_blocked' && block.AdminClearable ? 'RemovePhoneNumberBlock' : null; exports.phoneNumberBlockClearAction = phoneNumberBlockClearAction

// ---------------------------------------------------------------------------
// Shared formatting

// "Oct 13, 2026".
 const formatSMSUndeliverableDate = (iso) => {
  if (!iso) return ''
  const m = _moment2.default.call(void 0, iso)
  return m.isValid() ? m.format('MMM D, YYYY') : ''
}; exports.formatSMSUndeliverableDate = formatSMSUndeliverableDate

const onDate = (iso) => {
  const date = exports.formatSMSUndeliverableDate.call(void 0, iso)
  return date ? ` on ${date}` : ''
}

 const joinNames = (names, fallback = '') => {
  if (names.length <= 1) return names[0] || fallback
  if (names.length === 2) return `${names[0]} and ${names[1]}`
  return `${names.slice(0, -1).join(', ')}, and ${names[names.length - 1]}`
}; exports.joinNames = joinNames

// Normalizes a US national number to E.164 digits so a team's number and the
// backend's E.164 numbers compare equal however either was written.
const smsNumberDigits = (phone) => {
  const digits = _phone.getPhoneDigits.call(void 0, phone)
  return digits.length === 10 ? `1${digits}` : digits
}

 const isSameSMSNumber = (a, b) => {
  const digitsA = smsNumberDigits(a)
  return !!digitsA && digitsA === smsNumberDigits(b)
}; exports.isSameSMSNumber = isSameSMSNumber

// Where the patient should text START: the line the STOP or refused text was
// on (Twilio lifts its block only for that number), else the chat's number.
 const SMS_START_FALLBACK_LINE = 'your number'; exports.SMS_START_FALLBACK_LINE = SMS_START_FALLBACK_LINE
const startLine = (row, chatNumbers = []) =>
  _phone.formatPhoneNumber.call(void 0, row.SendingNumber || chatNumbers[0]) || exports.SMS_START_FALLBACK_LINE

const SOMEONE = 'a staff member'
const AN_ADMIN = 'an admin'

// ---------------------------------------------------------------------------
// Conversation banner

 const SMS_SECURE_STILL_READS_COPY =
  'They can still read and reply through their secure link or email.'; exports.SMS_SECURE_STILL_READS_COPY = SMS_SECURE_STILL_READS_COPY
 const SMS_UNDELIVERABLE_MIXED_COPY = 'Other recipients still get your texts.'; exports.SMS_UNDELIVERABLE_MIXED_COPY = SMS_UNDELIVERABLE_MIXED_COPY
 const SMS_ASK_ADMIN_TO_RESUBSCRIBE_COPY = 'An admin can resubscribe them.'; exports.SMS_ASK_ADMIN_TO_RESUBSCRIBE_COPY = SMS_ASK_ADMIN_TO_RESUBSCRIBE_COPY
 const SMS_ASK_ADMIN_TO_UNBLOCK_COPY = 'An admin can unblock this number.'; exports.SMS_ASK_ADMIN_TO_UNBLOCK_COPY = SMS_ASK_ADMIN_TO_UNBLOCK_COPY
 const SMS_ASK_ADMIN_TO_CLEAR_COPY = 'An admin can clear this.'; exports.SMS_ASK_ADMIN_TO_CLEAR_COPY = SMS_ASK_ADMIN_TO_CLEAR_COPY











const patientNameOr = (name, fallback = 'This patient') => _optionalChain([name, 'optionalAccess', _7 => _7.trim, 'call', _8 => _8()]) || fallback

// The banner's body for one row (the plan's "Proposed copy").
 const makeSMSUndeliverableBannerBody = (
  row,
  ctx = {},
) => {
  const name = patientNameOr(ctx.patientName)
  const date = onDate(row.CreatedAt)
  if (row.Shared) {
    const number = _phone.formatPhoneNumber.call(void 0, row.SendingNumber) || 'BloomText\'s notification number'
    return `${name} replied STOP to BloomText's notification number${date}. They can text START to ${number} to get notifications again.`
  }
  switch (row.Reason) {
    case 'opted_out':
      if (row.Source === 'staff') return `Marked opted out by ${_optionalChain([ctx, 'access', _9 => _9.createdByName, 'optionalAccess', _10 => _10.trim, 'call', _11 => _11()]) || SOMEONE}${date}.`
      return `${name} replied STOP${date}. They can text START to ${startLine(row, ctx.chatNumbers)} to get texts again.`
    case 'carrier_blocked':
      return `The carrier is blocking texts to this number. The patient can text START to ${startLine(row, ctx.chatNumbers)}.`
    case 'admin_blocked':
      return `An admin blocked this number${date}.`
    case 'unreachable':
      return 'This number can\'t receive texts (landline or unreachable).'
    default:
      return ''
  }
}; exports.makeSMSUndeliverableBannerBody = makeSMSUndeliverableBannerBody

// "Texts to Ann Able aren't being delivered: opted out." In a secure chat
// it's the notification texts that aren't delivered.
 const makeSMSUndeliverableBannerTitle = (
  row,
  patientName,
  conversationType,
) => {
  const what = conversationType === _chat.CHAT_TYPE.SECURE_PATIENT ? 'Text notifications' : 'Texts'
  return `${what} to ${patientNameOr(patientName, 'this patient')} aren't being delivered: ${exports.smsUndeliverableReasonPhrase.call(void 0, row.Reason)}.`
}; exports.makeSMSUndeliverableBannerTitle = makeSMSUndeliverableBannerTitle

// What a viewer who can't clear the row is told, when an admin could.
 const smsUndeliverableAskAdminCopy = (
  row,
  isAdmin,
) => {
  if (isAdmin) return ''
  switch (exports.smsUndeliverableClearAction.call(void 0, row)) {
    case 'ResubscribePatientSMS': return exports.SMS_ASK_ADMIN_TO_RESUBSCRIBE_COPY
    case 'UnblockPatientSMS': return exports.SMS_ASK_ADMIN_TO_UNBLOCK_COPY
    case 'ClearPatientSMSUnreachable': return exports.SMS_ASK_ADMIN_TO_CLEAR_COPY
    default: return ''
  }
}; exports.smsUndeliverableAskAdminCopy = smsUndeliverableAskAdminCopy

// One undeliverable recipient, as the banner selector gives it.


























// The banner names the top reason; any other reason on the same patient is
// added, so "text START" never reads as the whole fix when, say, an admin
// block stays after it.
const withOtherReasons = (body, top, rows) => {
  const others = [...new Set(rows.filter(r => r.Reason !== top.Reason).map(r => exports.smsUndeliverableReasonPhrase.call(void 0, r.Reason)))]
  return others.length ? `${body} Also ${exports.joinNames.call(void 0, others)}.` : body
}

 const makeSMSUndeliverableBannerCopy = ({
  patients,
  recipientCount,
  conversationType,
  chatNumbers,
  isAdmin,
}





) => {
  const entries = patients.map(({ patient, row, createdByName }) => {
    const action = isAdmin ? exports.smsUndeliverableClearAction.call(void 0, row) : null
    return {
      patientKey: patient.PatientKey,
      title: exports.makeSMSUndeliverableBannerTitle.call(void 0, row, patient.Name, conversationType),
      body: withOtherReasons(
        exports.makeSMSUndeliverableBannerBody.call(void 0, row, { patientName: patient.Name, createdByName, chatNumbers }),
        row,
        conversationType === _chat.CHAT_TYPE.SECURE_PATIENT ? exports.notificationSMSUndeliverable.call(void 0, patient) : exports.orgLineSMSUndeliverable.call(void 0, patient),
      ),
      hint: exports.smsUndeliverableAskAdminCopy.call(void 0, row, isAdmin),
      clearAction: action,
      clearLabel: action && exports.smsUndeliverableClearLabel.call(void 0, action),
    }
  })
  const notes = []
  if (entries.length && entries.length < recipientCount) notes.push(exports.SMS_UNDELIVERABLE_MIXED_COPY)
  if (entries.length && conversationType === _chat.CHAT_TYPE.SECURE_PATIENT) notes.push(exports.SMS_SECURE_STILL_READS_COPY)
  return { entries, notes }
}; exports.makeSMSUndeliverableBannerCopy = makeSMSUndeliverableBannerCopy

// ---------------------------------------------------------------------------
// Patient page: "Texting · Not deliverable"

 const SMS_TEXTING_LABEL = 'Texting'; exports.SMS_TEXTING_LABEL = SMS_TEXTING_LABEL
 const SMS_DELIVERABLE_LABEL = 'Deliverable'; exports.SMS_DELIVERABLE_LABEL = SMS_DELIVERABLE_LABEL
 const SMS_NOT_DELIVERABLE_LABEL = 'Not deliverable'; exports.SMS_NOT_DELIVERABLE_LABEL = SMS_NOT_DELIVERABLE_LABEL

// "Deliverable" or "Not deliverable" (org-line rows only).
 const smsDeliverabilityLabel = (patient) =>
  exports.isSMSDeliverable.call(void 0, patient) ? exports.SMS_DELIVERABLE_LABEL : exports.SMS_NOT_DELIVERABLE_LABEL; exports.smsDeliverabilityLabel = smsDeliverabilityLabel

// "Texting · Not deliverable".
 const smsTextingStateLabel = (patient) =>
  `${exports.SMS_TEXTING_LABEL} · ${exports.smsDeliverabilityLabel.call(void 0, patient)}`; exports.smsTextingStateLabel = smsTextingStateLabel













// One line of the patient page's Texting row. Every row is listed, Shared
// ones included (labelled as the notification number's).
 const describeSMSUndeliverableRow = (
  row,
  ctx = {},
) => {
  const date = onDate(row.CreatedAt)
  const line = startLine(row, ctx.chatNumbers)
  const by = (fallback) => _optionalChain([ctx, 'access', _12 => _12.createdByName, 'optionalAccess', _13 => _13.trim, 'call', _14 => _14()]) || fallback
  const keyword = _optionalChain([row, 'access', _15 => _15.Note, 'optionalAccess', _16 => _16.trim, 'call', _17 => _17()]) || 'STOP'
  if (row.Shared) {
    const number = _phone.formatPhoneNumber.call(void 0, row.SendingNumber) || 'BloomText\'s notification number'
    return {
      label: 'Opted out of notifications',
      detail: `Replied ${keyword} to BloomText's notification number${date}`,
      note: '',
      clears: `Stops secure-chat notification texts only. Clears when they text START to ${number}.`,
    }
  }
  switch (row.Reason) {
    case 'opted_out':
      if (row.Source === 'staff') {
        return {
          label: REASON_LABELS.opted_out,
          detail: `Marked by ${by(SOMEONE)}${date}`,
          note: _optionalChain([row, 'access', _18 => _18.Note, 'optionalAccess', _19 => _19.trim, 'call', _20 => _20()]) || '',
          clears: 'Clears when an admin resubscribes them, or when they text START.',
        }
      }
      return {
        label: REASON_LABELS.opted_out,
        detail: row.SendingNumber
          ? `Replied ${keyword} to ${_phone.formatPhoneNumber.call(void 0, row.SendingNumber)}${date}`
          : `Replied ${keyword}${date}`,
        note: '',
        clears: `Clears when they text START to ${line}.`,
      }
    case 'carrier_blocked':
      return {
        label: REASON_LABELS.carrier_blocked,
        detail: row.SendingNumber
          ? `The carrier refused a text from ${_phone.formatPhoneNumber.call(void 0, row.SendingNumber)}${date}`
          : `The carrier refused a text${date}`,
        note: '',
        clears: `Clears when they text START to ${line}.`,
      }
    case 'admin_blocked':
      return {
        label: REASON_LABELS.admin_blocked,
        detail: `Blocked by ${by(AN_ADMIN)}${date}`,
        note: _optionalChain([row, 'access', _21 => _21.Note, 'optionalAccess', _22 => _22.trim, 'call', _23 => _23()]) || '',
        clears: 'Clears when an admin unblocks the number. Texting START doesn\'t.',
      }
    case 'unreachable':
      return {
        label: REASON_LABELS.unreachable,
        detail: row.SendingNumber
          ? `A text from ${_phone.formatPhoneNumber.call(void 0, row.SendingNumber)} couldn't be delivered${date}`
          : `A text couldn't be delivered${date}`,
        note: '',
        clears: 'Clears when they text you, when their number is changed, or when an admin clears it.',
      }
    default:
      return { label: 'Not deliverable', detail: date.trim(), note: '', clears: '' }
  }
}; exports.describeSMSUndeliverableRow = describeSMSUndeliverableRow

// ---------------------------------------------------------------------------
// Block List (Team page) and the spam badge's "Block number"

 const SMS_BLOCK_LIST_HEADING = 'Blocked numbers apply to all of your organization\'s lines.'; exports.SMS_BLOCK_LIST_HEADING = SMS_BLOCK_LIST_HEADING

// One Block List row: the same reason label and who/when as the patient page.
 const describePhoneNumberBlock = (
  block,
  createdByName,
) => exports.describeSMSUndeliverableRow.call(void 0, 
  {
    Reason: block.Reason,
    Source: block.Source,
    SendingNumber: block.SendingNumber,
    CreatedAt: block.CreatedAt,
    CreatedBy: block.CreatedBy,
    Note: block.Note,
    AdminClearable: block.AdminClearable,
  },
  { createdByName },
); exports.describePhoneNumberBlock = describePhoneNumberBlock

 const SMS_SPAM_BLOCK_TITLE = 'Block number'; exports.SMS_SPAM_BLOCK_TITLE = SMS_SPAM_BLOCK_TITLE

 const makeSpamBlockConfirmCopy = (phoneNumber) =>
  `Block ${_phone.formatPhoneNumber.call(void 0, phoneNumber) || phoneNumber}? They won't be able to text your organization, and we won't text them.`; exports.makeSpamBlockConfirmCopy = makeSpamBlockConfirmCopy

// The patient page's Block action (BlockPatientSMS), admins only.
 const SMS_BLOCK_PATIENT_LABEL = 'Block number'; exports.SMS_BLOCK_PATIENT_LABEL = SMS_BLOCK_PATIENT_LABEL
 const makeSMSBlockPatientConfirmCopy = (patientName, phoneNumber) =>
  `Block ${_phone.formatPhoneNumber.call(void 0, phoneNumber) || phoneNumber}? ${patientNameOr(patientName)} won't be able to text your organization, and we won't text them.`; exports.makeSMSBlockPatientConfirmCopy = makeSMSBlockPatientConfirmCopy

// An admin's Clear on a number that can't receive texts
// (ClearPatientSMSUnreachable): texts are tried again.
 const SMS_CLEAR_UNREACHABLE_TITLE = 'Clear and try again'; exports.SMS_CLEAR_UNREACHABLE_TITLE = SMS_CLEAR_UNREACHABLE_TITLE
 const SMS_CLEAR_UNREACHABLE_SUCCESS = 'Cleared. Texts will be tried again.'; exports.SMS_CLEAR_UNREACHABLE_SUCCESS = SMS_CLEAR_UNREACHABLE_SUCCESS
 const SMS_CLEAR_UNREACHABLE_FAILURE = 'Failed to clear'; exports.SMS_CLEAR_UNREACHABLE_FAILURE = SMS_CLEAR_UNREACHABLE_FAILURE
 const makeSMSClearUnreachableConfirmCopy = (patientName, phoneNumber) =>
  `Try texting ${patientNameOr(patientName, 'this patient')} at ${_phone.formatPhoneNumber.call(void 0, phoneNumber) || phoneNumber || 'their number'} again? If their carrier still can't deliver, it will be flagged again.`; exports.makeSMSClearUnreachableConfirmCopy = makeSMSClearUnreachableConfirmCopy

// ---------------------------------------------------------------------------
// Mark opted out / Resubscribe dialogs

 const SMS_MARK_OPTED_OUT_TITLE = 'Mark opted out'; exports.SMS_MARK_OPTED_OUT_TITLE = SMS_MARK_OPTED_OUT_TITLE
 const SMS_MARK_OPTED_OUT_COPY =
  'Use this when the patient asked by phone, in person or in writing to stop getting texts. Texts to this patient will be blocked in BloomText.'; exports.SMS_MARK_OPTED_OUT_COPY = SMS_MARK_OPTED_OUT_COPY
 const SMS_MARK_OPTED_OUT_CONFIRM_LABEL = 'Mark opted out'; exports.SMS_MARK_OPTED_OUT_CONFIRM_LABEL = SMS_MARK_OPTED_OUT_CONFIRM_LABEL

 const SMS_PREFERENCE_REASON_LABEL = 'Reason'; exports.SMS_PREFERENCE_REASON_LABEL = SMS_PREFERENCE_REASON_LABEL
 const SMS_MARK_OPTED_OUT_REASON_PLACEHOLDER = 'Asked by phone'; exports.SMS_MARK_OPTED_OUT_REASON_PLACEHOLDER = SMS_MARK_OPTED_OUT_REASON_PLACEHOLDER
 const SMS_RESUBSCRIBE_REASON_PLACEHOLDER = 'Asked at visit'; exports.SMS_RESUBSCRIBE_REASON_PLACEHOLDER = SMS_RESUBSCRIBE_REASON_PLACEHOLDER

// The resubscribe dialog's warning when other org-line rows stay after the
// staff opt-out clears: "Ann Able still won't get texts: blocked by carrier."
 const makeSMSResubscribeRemainingCopy = (
  patientName,
  rows,
) => {
  const remaining = (rows || []).filter(r => !r.Shared && !(r.Reason === 'opted_out' && r.Source === 'staff'))
  if (!remaining.length) return ''
  const reasons = [...new Set(exports.sortSMSUndeliverable.call(void 0, remaining).map(r => exports.smsUndeliverableReasonPhrase.call(void 0, r.Reason)))]
  return `${patientNameOr(patientName)} still won't get texts: ${exports.joinNames.call(void 0, reasons)}.`
}; exports.makeSMSResubscribeRemainingCopy = makeSMSResubscribeRemainingCopy

// The mark-opted-out dialog's warning when other patients in the org share
// the phone: the list is kept per phone, so it stops texts to all of them.
 const makeSMSSharedPhoneWarning = (otherNames) => {
  const names = otherNames.map(n => n.trim() || 'another patient')
  return names.length === 1
    ? `This phone is shared with ${names[0]}. Texts to both will stop.`
    : `This phone is shared with ${exports.joinNames.call(void 0, names)}. Texts to all of them will stop.`
}; exports.makeSMSSharedPhoneWarning = makeSMSSharedPhoneWarning

// The backend's public client errors ("a reason is required") are safe to
// show; anything else gets the caller's fallback.
 const smsPreferenceErrorMessage = (error, fallback) => {
  const message = _optionalChain([(error ), 'optionalAccess', _24 => _24.Error])
  if (typeof message !== 'string' || !message) return fallback
  return message.charAt(0).toUpperCase() + message.slice(1)
}; exports.smsPreferenceErrorMessage = smsPreferenceErrorMessage

// ---------------------------------------------------------------------------
// Broadcast (campaign) message errors (D11)

const BROADCAST_ERROR_TEXT = {
  sms_undeliverable_opted_out: 'Not deliverable: opted out',
  sms_undeliverable_carrier_blocked: 'Not deliverable: blocked by carrier',
  sms_undeliverable_admin_blocked: 'Not deliverable: blocked by admin',
  sms_undeliverable_unreachable: 'Not deliverable: can\'t receive texts',
  consent_required: 'Not sent: the patient hasn\'t agreed to texts yet',
  consent_not_sent: 'Not sent: waited for consent. Send again if needed.',
}

// "Not deliverable: opted out" for an undeliverable recipient's campaign
// message, "Not sent: ..." for a consent code; null for any other code (the
// caller shows its own text).
 const broadcastErrorCodeText = (code) =>
  (code && BROADCAST_ERROR_TEXT[code]) || null; exports.broadcastErrorCodeText = broadcastErrorCodeText

// ---------------------------------------------------------------------------
// Scheduled messages

 const SMS_UNDELIVERABLE_SCHEDULED_FAILURE_TEXT = {
  opted_out: 'Not sent: patient opted out',
  carrier_blocked: 'Not sent: blocked by carrier',
  admin_blocked: 'Not sent: blocked by admin',
  unreachable: 'Not sent: can\'t receive texts',
}; exports.SMS_UNDELIVERABLE_SCHEDULED_FAILURE_TEXT = SMS_UNDELIVERABLE_SCHEDULED_FAILURE_TEXT

// ---------------------------------------------------------------------------
// Message delivery badges (SMSDeliveryOutcome)

 const SMS_REJECTED_STATUS = 'rejected'; exports.SMS_REJECTED_STATUS = SMS_REJECTED_STATUS
// Error codes on a refused text. 'recipient_unsubscribed' is an opt-out;
// 'carrier_blocked' is Twilio's 21610; 'admin_blocked' is an admin's block;
// 'unreachable' is a number Twilio reported can't receive texts (30006).
// Any other code (the consent codes 'consent_not_sent' and
// 'consent_required' among them) names no list reason and reads neutrally.
 const SMS_OPTED_OUT_ERROR_CODE = 'recipient_unsubscribed'; exports.SMS_OPTED_OUT_ERROR_CODE = SMS_OPTED_OUT_ERROR_CODE
 const SMS_CARRIER_BLOCKED_ERROR_CODE = 'carrier_blocked'; exports.SMS_CARRIER_BLOCKED_ERROR_CODE = SMS_CARRIER_BLOCKED_ERROR_CODE
 const SMS_ADMIN_BLOCKED_ERROR_CODE = 'admin_blocked'; exports.SMS_ADMIN_BLOCKED_ERROR_CODE = SMS_ADMIN_BLOCKED_ERROR_CODE
 const SMS_UNREACHABLE_ERROR_CODE = 'unreachable'; exports.SMS_UNREACHABLE_ERROR_CODE = SMS_UNREACHABLE_ERROR_CODE

 const SMS_REJECTED_LABEL = 'SMS rejected'; exports.SMS_REJECTED_LABEL = SMS_REJECTED_LABEL
 const SMS_PARTIALLY_REJECTED_LABEL = 'SMS partially rejected'; exports.SMS_PARTIALLY_REJECTED_LABEL = SMS_PARTIALLY_REJECTED_LABEL
 const SMS_CARRIER_BLOCKED_LABEL = REASON_LABELS.carrier_blocked; exports.SMS_CARRIER_BLOCKED_LABEL = SMS_CARRIER_BLOCKED_LABEL
 const SMS_ADMIN_BLOCKED_LABEL = REASON_LABELS.admin_blocked; exports.SMS_ADMIN_BLOCKED_LABEL = SMS_ADMIN_BLOCKED_LABEL
 const SMS_UNREACHABLE_LABEL = REASON_LABELS.unreachable; exports.SMS_UNREACHABLE_LABEL = SMS_UNREACHABLE_LABEL

// The list reason behind a refused text's error code; null for a code that
// names none.
 const smsErrorCodeReason = (code) => {
  if (code === exports.SMS_OPTED_OUT_ERROR_CODE) return 'opted_out'
  if (code === exports.SMS_CARRIER_BLOCKED_ERROR_CODE) return 'carrier_blocked'
  if (code === exports.SMS_ADMIN_BLOCKED_ERROR_CODE) return 'admin_blocked'
  if (code === exports.SMS_UNREACHABLE_ERROR_CODE) return 'unreachable'
  return null
}; exports.smsErrorCodeReason = smsErrorCodeReason


















 const summarizeSMSOutcomes = (
  outcomes,
) => {
  if (!_optionalChain([outcomes, 'optionalAccess', _25 => _25.length])) return null
  const rejected = outcomes.filter(o => o.Status === exports.SMS_REJECTED_STATUS)
  if (!rejected.length) return null
  const partial = rejected.length < outcomes.length
  const optedOut = rejected.filter(o => o.ErrorCode === exports.SMS_OPTED_OUT_ERROR_CODE)
  const carrierBlocked = rejected.filter(o => o.ErrorCode === exports.SMS_CARRIER_BLOCKED_ERROR_CODE)
  const adminBlocked = rejected.filter(o => o.ErrorCode === exports.SMS_ADMIN_BLOCKED_ERROR_CODE)
  const unreachable = rejected.filter(o => o.ErrorCode === exports.SMS_UNREACHABLE_ERROR_CODE)
  let label = exports.SMS_REJECTED_LABEL
  if (partial) label = exports.SMS_PARTIALLY_REJECTED_LABEL
  else if (carrierBlocked.length === rejected.length) label = exports.SMS_CARRIER_BLOCKED_LABEL
  else if (adminBlocked.length === rejected.length) label = exports.SMS_ADMIN_BLOCKED_LABEL
  else if (unreachable.length === rejected.length) label = exports.SMS_UNREACHABLE_LABEL
  return {
    label,
    partial,
    rejectedPatientKeys: rejected.map(o => o.PatientKey),
    optedOutPatientKeys: optedOut.map(o => o.PatientKey),
    carrierBlockedPatientKeys: carrierBlocked.map(o => o.PatientKey),
    adminBlockedPatientKeys: adminBlocked.map(o => o.PatientKey),
    unreachablePatientKeys: unreachable.map(o => o.PatientKey),
  }
}; exports.summarizeSMSOutcomes = summarizeSMSOutcomes

// Badge recipient names, each blocked one marked with its reason unless the
// badge label already says it.
 const describeSMSRejectedRecipients = (
  summary,
  nameOf,
) => {
  const carrierBlocked = new Set(summary.carrierBlockedPatientKeys)
  const adminBlocked = new Set(summary.adminBlockedPatientKeys)
  const unreachable = new Set(summary.unreachablePatientKeys)
  return summary.rejectedPatientKeys.map(k => {
    const name = nameOf(k)
    if (summary.label !== exports.SMS_CARRIER_BLOCKED_LABEL && carrierBlocked.has(k)) {
      return `${name} (blocked by carrier)`
    }
    if (summary.label !== exports.SMS_ADMIN_BLOCKED_LABEL && adminBlocked.has(k)) {
      return `${name} (blocked by admin)`
    }
    if (summary.label !== exports.SMS_UNREACHABLE_LABEL && unreachable.has(k)) {
      return `${name} (can't receive texts)`
    }
    return name
  })
}; exports.describeSMSRejectedRecipients = describeSMSRejectedRecipients

 const smsRejectionTooltipTitle = (summary) => {
  if (summary.label === exports.SMS_CARRIER_BLOCKED_LABEL) return 'Carrier blocked texts to'
  if (summary.label === exports.SMS_ADMIN_BLOCKED_LABEL) return 'Admin blocked texts to'
  if (summary.label === exports.SMS_UNREACHABLE_LABEL) return 'Couldn\'t text'
  if (!summary.partial && summary.optedOutPatientKeys.length === summary.rejectedPatientKeys.length) {
    return 'Opted out of texts'
  }
  return 'Not received by'
}; exports.smsRejectionTooltipTitle = smsRejectionTooltipTitle

// The copy below names the patient whenever their name is known, so a
// notice that outlives its chat still says whose text it was. The
// 'This patient' constants are the fallback for a patient with no name.
 const SMS_UNSUBSCRIBED_NOTICE =
  'This patient opted out of texts. You cannot message them by text.'; exports.SMS_UNSUBSCRIBED_NOTICE = SMS_UNSUBSCRIBED_NOTICE
 const SMS_CARRIER_BLOCKED_NOTICE =
  'This patient\'s carrier blocked this text. Ask them to text START to this number.'; exports.SMS_CARRIER_BLOCKED_NOTICE = SMS_CARRIER_BLOCKED_NOTICE
 const SMS_ADMIN_BLOCKED_NOTICE =
  'This patient\'s number is blocked by an admin, so this text wasn\'t sent.'; exports.SMS_ADMIN_BLOCKED_NOTICE = SMS_ADMIN_BLOCKED_NOTICE
 const SMS_UNREACHABLE_NOTICE =
  'This patient\'s number can\'t receive texts (landline or unreachable), so this text wasn\'t sent.'; exports.SMS_UNREACHABLE_NOTICE = SMS_UNREACHABLE_NOTICE
 const SMS_NOT_SENT_NOTICE =
  'This patient did not receive this text.'; exports.SMS_NOT_SENT_NOTICE = SMS_NOT_SENT_NOTICE

// Replaces the fallback copy's leading 'This patient' with the name.
const naming = (copy, name) =>
  name ? copy.replace(/^This patient('s)?/, (_, possessive) => `${name}${_nullishCoalesce(possessive, () => ( ''))}`) : copy

 const patientDisplayNames = (
  patientKeys,
  patients,
) => patientKeys.map(k => _optionalChain([patients, 'access', _26 => _26[k], 'optionalAccess', _27 => _27.Name]) || 'A patient'); exports.patientDisplayNames = patientDisplayNames

// A refusal whose error code names no list reason.

const REJECTION_GROUP_ORDER = [...exports.SMS_UNDELIVERABLE_REASON_ORDER, 'other']

const SINGLE_NOTICE = {
  opted_out: exports.SMS_UNSUBSCRIBED_NOTICE,
  carrier_blocked: exports.SMS_CARRIER_BLOCKED_NOTICE,
  admin_blocked: exports.SMS_ADMIN_BLOCKED_NOTICE,
  unreachable: exports.SMS_UNREACHABLE_NOTICE,
  other: exports.SMS_NOT_SENT_NOTICE,
}

const GROUP_NOTICE = {
  opted_out: names => `${names} opted out of texts. You cannot message them by text.`,
  carrier_blocked: names => `The carriers of ${names} blocked this text. Ask them to text START to this number.`,
  admin_blocked: names => `The numbers of ${names} are blocked by an admin, so this text wasn't sent.`,
  unreachable: names => `The numbers of ${names} can't receive texts (landline or unreachable), so this text wasn't sent.`,
  other: names => `${names} did not receive this text.`,
}

// One-time notice shown when a message's text was refused. A single reason
// for everyone gets that reason's notice; otherwise it names who did not
// receive it, grouped by reason.
 const makeSMSRejectionNotice = (
  summary,
  patients,
) => {
  const reasonOf = (k) => {
    if (summary.optedOutPatientKeys.includes(k)) return 'opted_out'
    if (summary.carrierBlockedPatientKeys.includes(k)) return 'carrier_blocked'
    if (summary.adminBlockedPatientKeys.includes(k)) return 'admin_blocked'
    if (summary.unreachablePatientKeys.includes(k)) return 'unreachable'
    return 'other'
  }
  const groups = REJECTION_GROUP_ORDER
    .map(reason => ({ reason, keys: summary.rejectedPatientKeys.filter(k => reasonOf(k) === reason) }))
    .filter(g => g.keys.length)

  const [only] = groups
  if (!summary.partial && groups.length === 1 && only) {
    if (only.keys.length <= 1) return naming(SINGLE_NOTICE[only.reason], _optionalChain([patients, 'access', _28 => _28[only.keys[0] ], 'optionalAccess', _29 => _29.Name]))
    return GROUP_NOTICE[only.reason](exports.joinNames.call(void 0, exports.patientDisplayNames.call(void 0, only.keys, patients)))
  }
  return groups.map((g, i) => {
    const line = `${exports.joinNames.call(void 0, exports.patientDisplayNames.call(void 0, g.keys, patients))} did not receive ${i === 0 ? 'this text' : 'it'}`
    return g.reason === 'other' ? `${line}.` : `${line}: ${exports.smsUndeliverableReasonPhrase.call(void 0, g.reason)}.`
  }).join(' ')
}; exports.makeSMSRejectionNotice = makeSMSRejectionNotice
